import { getProductPrice } from "@lib/util/get-product-price"
import { HttpTypes } from "@medusajs/types"

export default function ProductPrice({
  product,
  variant,
}: {
  product: HttpTypes.StoreProduct
  variant?: HttpTypes.StoreProductVariant
}) {
  const { cheapestPrice, variantPrice } = getProductPrice({
    product,
    variantId: variant?.id,
  })

  const selectedPrice = variant ? variantPrice : cheapestPrice

  if (!selectedPrice) {
    return <div className="block w-32 h-9 bg-gray-100 animate-pulse" />
  }

  const hasDiscount = selectedPrice.price_type === "sale"

  return (
    <div className="flex flex-col gap-y-1">
      {/* Price + Original Price */}
      <div className="flex flex-wrap items-baseline gap-x-2.5 gap-y-2">
        <span className="text-xl small:text-2xl font-bold text-brand-navy">
          {!variant && "From "}
          <span
            data-testid="product-price"
            data-value={selectedPrice.calculated_price_number}
          >
            {selectedPrice.calculated_price}
          </span>
        </span>
        {hasDiscount && (
          <span
            className="text-base small:text-lg text-red-300 line-through"
            data-testid="original-product-price"
            data-value={selectedPrice.original_price_number}
          >
            {selectedPrice.original_price}
          </span>
        )}
      </div>

      {/* Buy now, pay later */}
      <div className="flex flex-wrap items-center gap-x-1 gap-y-1">
        <span className="text-xs text-gray-500">Buy now, pay later with</span>
        <span className="text-xs font-semibold text-[#FFB3C7]">Klarna</span>
        <span className="text-xs text-gray-400">·</span>
        <span className="text-xs font-semibold text-[#B2FCE4]">Clearpay</span>
        <span className="text-xs text-gray-400">·</span>
        <span className="text-xs font-semibold text-[#003087]">PayPal</span>
      </div>
    </div>
  )
}
